import Section from "@/components/Section";
import Breadcrumb from "@/components/UI-Kit/Breadcrumb";
import { getBreadcrumbRoute } from "@/utils/getBreadcrumbRoute";
import { Box, Container, Typography, useTheme } from "@mui/material";
import { useLocation } from "react-router";
import icon_url from "@/assets/icons/troubleshooting/troubleshooting.svg";
import thumbnail from "@/assets/images/troubleshooting/troubleshooting_thumbnail.png";
import SolutionsSection from "./components/SolutionsSection";
import QuestionsSection from "./components/QuestionsSection";
import AnimatedImage from "@/components/UI-Kit/AnimatedImage";

const Troubleshooting = () => {
  const theme = useTheme();
  const location = useLocation();
  return (
    <>
      <Container sx={{ pt: { xs: 3, lg: 0 }, pb: { xs: 4, md: 0 } }}>
        <Breadcrumb options={getBreadcrumbRoute(location)} />
      </Container>
      <Section pt={{ xs: 0, md: 4.25 }} pb={{ xs: 0, md: 3 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: { md: "space-between" },
          }}
        >
          <Box
            sx={{
              marginBottom: { xs: "24px", md: "0px" },
              alignSelf: { xs: "start", md: "center" },
            }}
          >
            <Typography
              variant="h1"
              color={theme.palette.grey[800]}
              sx={{
                maxWidth: "795px",
                marginBottom: { xs: "16px", md: "26px" },
              }}
            >
              Troubleshooting
            </Typography>
            <Typography
              variant="subtitle1"
              component="p"
              color={theme.palette.grey[600]}
              sx={{
                maxWidth: "674px",
              }}
            >
              Our comprehensive resource to help you identify and resolve common issues quickly and efficiently.
            </Typography>
          </Box>
          <AnimatedImage
            sx={{
              width: "100%",
              maxWidth: { xs: "343px", md: "604px" },
              img: {
                width: "100%",
                height: "auto",
              },
            }}
            thumbnailUrl={thumbnail}
            mainUrl={icon_url}
            alt="troubleshooting"
          />
        </Box>
      </Section>
      <SolutionsSection />
      <QuestionsSection />
    </>
  );
};

export default Troubleshooting;
